
  import {computed, defineComponent, onMounted, reactive, toRefs} from "vue";
  import SwitchView from "@/components/SwitchView.vue";
  import InventoriesCompanyLocationsList from "./InventoriesCompanyLocationsList.vue";
  import InventoriesCompanyLocationsTable from "./InventoriesCompanyLocationsTable.vue";
  import InventoriesCompanyLocationsDialog from "./dialog/InventoriesCompanyLocationsDialog.vue";
  import eventBus from "@/eventbus";
  import {MessageTypes} from "@/components/message-types";
  import CompanyLocationService, {CompanyLocationV2Dto} from "@/service/CompanyLocationService";
  import {t} from "@/mixin/mixins";

  export default defineComponent({
    name: "InventoriesCompanyLocations",
    components: {
      SwitchView,
      InventoriesCompanyLocationsList,
      InventoriesCompanyLocationsTable,
      InventoriesCompanyLocationsDialog
    },
    setup() {

      const initialState = {
        companyLocations: new Array<CompanyLocationV2Dto>(),
        search: ""
      };

      const state = reactive({...initialState});

      onMounted(() => {
        findCompanyLocations();

        eventBus.$on(MessageTypes.COMPANY_LOCATION_CREATED, (companyLocation: CompanyLocationV2Dto) => {
          let exists = state.companyLocations.find(location => location.id == companyLocation.id);
          if (exists) {
            state.companyLocations = state.companyLocations.map(location => {
              if (location.id == companyLocation.id) {location = companyLocation;}
              return location;
            });
          } else {
            state.companyLocations.push(companyLocation);
          }
        });
        eventBus.$on(MessageTypes.COMPANY_LOCATION_DELETED, (companyLocationId: string) => {
          state.companyLocations = state.companyLocations.filter(location => {
            return location.id != companyLocationId;
          });
        });
      });

      // The v2 API has no search term, so the locations are filtered here. As before, a term needs three characters.
      const filteredCompanyLocations = computed(() => {
        const term = state.search ? state.search.trim().toLowerCase() : "";
        if (term.length < 3) return state.companyLocations;
        return state.companyLocations.filter(location =>
          [location.name, location.street, location.zip, location.city]
            .some(value => value && value.toLowerCase().includes(term)));
      });

      const findCompanyLocations = () => {
        CompanyLocationService.findCompanyLocations()
          .then(companyLocations => {
            state.companyLocations = companyLocations;
          })
          .catch(() => {
            eventBus.$emit(MessageTypes.ERROR, t("errors.generalError"));
          });
      };

      const openCompanyLocationDialog = (companyLocation: CompanyLocationV2Dto | null = null) => {
        eventBus.$emit(MessageTypes.OPEN_COMPANY_LOCATION_DIALOG, companyLocation);
      };

      return {
        ...toRefs(state),
        filteredCompanyLocations,
        openCompanyLocationDialog
      };
    }
  });
